import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EntraConfig } from '@rubii/share/src/classes/data-source-config';

export interface EntraConfigDialogData {
  payload: EntraConfig;
  domain: string;
}

@Component({
  selector: 'app-entra-config',
  templateUrl: './entra-config.component.html',
  styleUrls: ['./entra-config.component.scss']
})
export class EntraConfigComponent implements OnInit {
  payload: EntraConfig;
  domain: string;

  constructor(
    public dialogRef: MatDialogRef<EntraConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EntraConfigDialogData
  ) {
    this.payload = data.payload;
    this.domain = data.domain;
  }

  ngOnInit(): void {
  }
}
